import { Helmet } from "react-helmet";
import { Link, useNavigate } from "react-router-dom";

function SubjectsPage(){
  const subjects = [
    { label: "English", slug: "english" },
    { label: "Mathematics", slug: "maths" },
    { label: "EVS", slug: "science" },
    { label: "Hindi", slug: "hindi" },
    { label: "Science", slug: "science" },
    { label: "Tracing", slug: "tracing" },
    { label: "Coloring", slug: "coloring" },
    { label: "Matching", slug: "matching" },
    { label: "Puzzle", slug: "puzzle" }
  ];
  const navigate = useNavigate();

  return(
    <div
      style={{
        minHeight: "100vh",
        padding: "28px",
        background: "#F7FAFF"
      }}
    >
      <Helmet>
        <title>Subjects – PracticeNest</title>
        <meta
          name="description"
          content="Choose a subject like Maths, English, Science, Tracing, Coloring, Matching, or Puzzle."
        />
        <link rel="canonical" href="https://practicenest.in/subjects" />
      </Helmet>
      <div style={{maxWidth: "1000px", margin: "0 auto"}}>
        <div style={{display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "18px"}}>
          <button
            onClick={() => navigate(-1)}
            style={{
              padding: "6px 10px",
              borderRadius: "10px",
              border: "1px solid #cfd8e3",
              background: "#fff",
              cursor: "pointer"
            }}
          >
            ←
          </button>
          <Link to="/" style={{textDecoration: "none", fontWeight: "600"}}>Home</Link>
        </div>
        <h1 style={{fontSize: "32px", textAlign: "center", marginBottom: "24px"}}>Choose Subject</h1>

        <div style={{display: "grid", gridTemplateColumns: "1fr", gap: "16px"}}>
          {subjects.map((s, idx) => (
            <Link
              key={`${s.slug}-${idx}`}
              to={`/grades?subject=${encodeURIComponent(s.slug)}`}
              state={{ fromApp: true }}
              style={{
                textDecoration: "none",
                color: "inherit",
                background: "#fff",
                padding: "20px",
                borderRadius: "16px",
                border: "1px solid #e6eef7",
                boxShadow: "0 6px 14px rgba(0,0,0,0.05)",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between"
              }}
            >
              <div style={{display: "flex", alignItems: "center", gap: "18px"}}>
                <div style={{fontSize: "22px", fontWeight: "700", color: "#5B6B7B", width: "36px"}}>
                  {String(idx + 1).padStart(2, "0")}
                </div>
                <div>
                  <div style={{fontSize: "20px", fontWeight: "700"}}>{s.label}</div>
                  {/* subtopics count removed */}
                </div>
              </div>
              <div style={{
                width: "32px",
                height: "32px",
                borderRadius: "8px",
                border: "1px solid #cfd8e3",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#9AA7B2",
                fontSize: "16px"
              }}>
                ▾
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}

export default SubjectsPage;
